// extracted by mini-css-extract-plugin
export default {"wrap":"Brands_wrap__Scsrx","list":"Brands_list__2CL0j","item":"Brands_item__5sQrC"};